// src/components/LoginPage.js
import React, { useState } from 'react';
import './LoginPage.css';
import { useNavigate } from 'react-router-dom';
import CryptoJS from 'crypto-js';

const LoginPage = () => {
  const navigate = useNavigate();

  // 表单状态
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    remember: false
  });
  
  // UI状态
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [errors, setErrors] = useState({});
  const [darkMode, setDarkMode] = useState(false);
  const [apiError, setApiError] = useState('');

  // 处理表单变化
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
    
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null
      });
    }
    
    if (apiError) setApiError('');
  };

  // 切换密码可见性
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // 切换暗色模式
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  // 表单验证
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.username.trim()) {
      newErrors.username = '请输入用户名';
    }
    
    if (!formData.password) {
      newErrors.password = '请输入密码';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 处理表单提交
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      setIsLoading(true);
      setApiError('');
      
      try {
        const response = await fetch('http://59.56.207.14:8077/api/auth-logs/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            username: formData.username,
            password: formData.password
          })
        });
        
        const data = await response.json();
        
        if (!response.ok) {
          throw new Error(data.message);
        }
        
        if (data.code === 0) {
          setLoginSuccess(true);
          
          if (data.data && data.data.token) {
            localStorage.setItem('authToken', data.data.token);
          }
          const authCode = generateAuthorizationCode();
          sessionStorage.setItem('authCode', JSON.stringify(authCode));
          setTimeout(() => {
            navigate('/system', { 
              state: { 
                authorizationCode: authCode.code 
              } 
            });
          }, 1000);
        } else {
          setApiError(data.message);
        }
      } catch (error) {
        setApiError(error.message || '登录失败');
      } finally {
        setIsLoading(false);
      }
    }
  };
  const generateAuthorizationCode = () => {
    const randomString = Math.random().toString(36).substring(2, 18);
    const timestamp = Date.now().toString(36);
    const baseCode = `${randomString}-${timestamp}`;
    const encryptedCode = CryptoJS.SHA256(baseCode).toString(CryptoJS.enc.Hex);
    
    return {
      code: encryptedCode,
      expiration: Date.now() + 3600000 // 1小时有效期
    };
  };
  
  return (
    <div className={`login-container ${darkMode ? 'dark-mode' : ''}`}>
      <div className="login-card">
        {/* 左侧品牌展示区 */}
        <div className="brand-section">
          <div className="brand-overlay"></div>
          <div className="brand-content">
            <div className="logo">
            <img src="/logo.png" alt="泉州师范学院" className="header-logo" />
            </div>
            <h1 className="brand-title">统一身份认证——手机绑定管理端</h1>
          </div>
        </div>
        
        {/* 右侧登录表单区 */}
        <div className="login-section">
          <div className="login-header">
            <h2 className="login-title">欢迎回来</h2>
            <p className="login-subtitle">请登录您的账号继续使用</p>
          </div>
          
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="username">账号</label>
              <div className={`input-container ${errors.username ? 'error' : ''}`}>
                <i className="fas fa-user"></i>
                <input
                  type="text"
                  id="username"
                  name="username"
                  placeholder="请输入用户名或邮箱"
                  value={formData.username}
                  onChange={handleChange}
                />
              </div>
              {errors.username && <div className="error-message">{errors.username}</div>}
            </div>
            
            <div className="form-group">
              <label htmlFor="password">密码</label>
              <div className={`input-container ${errors.password ? 'error' : ''}`}>
                <i className="fas fa-lock"></i>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="请输入密码"
                  value={formData.password}
                  onChange={handleChange}
                />
                <button 
                  type="button" 
                  className="password-toggle"
                  onClick={togglePasswordVisibility}
                >
                  <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
              {errors.password && <div className="error-message">{errors.password}</div>}
            </div>
            
            <div className="form-options">
              <div className="remember-me">
                <input
                  type="checkbox"
                  id="remember"
                  name="remember"
                  checked={formData.remember}
                  onChange={handleChange}
                />
                <label htmlFor="remember">记住我</label>
              </div>
            </div>
            
            {apiError && <div className="api-error-message">{apiError}</div>}
            
            <button 
              type="submit" 
              className={`login-button ${loginSuccess ? 'success' : ''}`}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i> 登录中...
                </>
              ) : loginSuccess ? (
                <>
                  <i className="fas fa-check"></i> 登录成功
                </>
              ) : "登录系统"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;